function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#538cc9;stroke-width:0px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_9932"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_30419",
  className: "cls-1",
  d: "M56.31,494.8l348.26,17.02c18.35,1.23,34.22-12.65,35.45-31,.1-1.48.1-2.97,0-4.45l-1.55-31.62c-.59-10.18-4.95-19.77-12.24-26.9-7.16-7.36-16.79-11.83-27.03-12.56l-203.4-10.15L502.72,88.2c13.69-14.83,12.78-37.95-2.05-51.64-.13-.12-.26-.24-.39-.36l-23.45-23.45c-13.79-15.47-37.42-17.08-53.19-3.64L115.56,317.18l-9.61-205.14c-1.35-20.88-17.98-37.51-38.86-38.86l-31.57-1.49C17.17,70.46,1.3,84.34.07,102.69c-.1,1.48-.1,2.97,0,4.45l17.02,348.26c1.49,21.05,18.24,37.8,39.29,39.29l-.07.11Z"
}));

function SvgArrow01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.42 511.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow01);
export default __webpack_public_path__ + "static/media/arrow-01.b37a3cee.svg";
export { ForwardRef as ReactComponent };